import { signIn as signIn$1, getCsrfToken } from 'next-auth/react';

/**
 * Readonly array of valid auth params.
 *
 * `code_challenge` = NextAuth generated code challenge.
 * `redirect_uri` = Redirect URI passed in method or default.
 * `state` = NextAuth generated unique state.
 */ const VALID_AUTH_PARAMS = [
    'code_challenge',
    'redirect_uri',
    'state'
];
/**
 * Custom signIn() method wrapper around NextAuth APIs.
 * Generates state, a code challenge and other params necessary to complete Okta sign-in.
 */ const signIn = async (signInOptions, authorizationParams)=>{
    const { legacy, ...options } = signInOptions ?? {};
    // If legacy param is set, short circuit to use Next-Auth / Okta-Hosted login
    if (legacy) {
        void signIn$1('okta', options, authorizationParams);
        return;
    }
    const csrfToken = await getCsrfToken() ?? '';
    const _signInApiPath = '/api/auth/signin/okta';
    const { callbackUrl = window.location.href } = options;
    const res = await fetch(_signInApiPath, {
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            csrfToken,
            callbackUrl,
            json: 'true'
        })
    });
    const data = await res.json();
    if (!isSignInResponse(data)) return;
    const dataUrl = data.url;
    const oktaUrl = new URL(dataUrl);
    const filteredSearchParams = new URLSearchParams();
    VALID_AUTH_PARAMS.forEach((key)=>{
        if (!oktaUrl.searchParams.has(key)) return;
        const paramValue = oktaUrl.searchParams.get(key);
        if (!paramValue) return;
        filteredSearchParams.append(key, paramValue);
    });
    // If explicitly pass redirect: false, return the query string
    if (options.redirect === false) {
        // Params only valid for 15 min, after that trigger refresh
        setTimeout(()=>{
            window.location.reload();
        }, 1000 * 60 * 15);
        return filteredSearchParams.toString();
    }
    // Assumes /login route exists that redirects to auth-web domain
    window.location.href = `/login?${filteredSearchParams.toString()}`;
};
/**
 * Guard to ensure response shape matches SignIn response with redirect URL.
 */ function isSignInResponse(data) {
    return Object.prototype.hasOwnProperty.call(data, 'url');
}

export { signIn };
//# sourceMappingURL=signIn.js.map
